import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=f0150b08&scoped=true"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=f0150b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0150b08",
  null
  
)

export default component.exports